/**
 * Pine Straw Store — Theme JS
 * Handles: Shopify cart (AJAX API), cart drawer, mobile menu,
 * smooth scroll, scroll spy, FAQ accordion, back-to-top
 */
(function(){
  'use strict';

  /* ══════════════════════════════════════
     MOBILE MENU
  ══════════════════════════════════════ */
  var hamburger = document.getElementById('hamburger-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  var menuOverlay = document.getElementById('menu-overlay');
  var menuClose = document.getElementById('menu-close');

  function openMenu(){
    if(!mobileMenu) return;
    mobileMenu.classList.add('open');
    menuOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu(){
    if(!mobileMenu) return;
    mobileMenu.classList.remove('open');
    menuOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if(hamburger) hamburger.addEventListener('click', openMenu);
  if(menuClose) menuClose.addEventListener('click', closeMenu);
  if(menuOverlay) menuOverlay.addEventListener('click', closeMenu);
  document.querySelectorAll('.mob-link').forEach(function(a){
    a.addEventListener('click', closeMenu);
  });

  /* ══════════════════════════════════════
     SHOPIFY CART (AJAX API)
  ══════════════════════════════════════ */
  function fetchCart(callback){
    fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){ if(callback) callback(cart); })
      .catch(function(e){ console.error('Cart fetch error:', e); });
  }

  function formatMoney(cents){
    return '$' + (cents / 100).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  /* ── Store sale in the drawer ──
     cart.js carries no compare-at price, so fetch /products/<handle>.js once per
     product per page load. Savings = (compare-at − original price) × qty, summed —
     the same rule the cart page uses in Liquid. Only while window.PSS_SALE is on
     and not past its end date (snippets/sale-config). */
  var compareCache = {};
  var saleRenderSeq = 0;

  function saleLive(){
    var s = window.PSS_SALE;
    return !!(s && s.on && !s.over);
  }

  function loadCompare(items){
    var handles = [];
    items.forEach(function(i){
      if(i.handle && !compareCache[i.handle] && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });
    return Promise.all(handles.map(function(h){
      return fetch('/products/' + h + '.js', {credentials:'same-origin'})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          var m = {};
          if(p && p.variants) p.variants.forEach(function(v){ m[v.id] = v.compare_at_price || 0; });
          compareCache[h] = m;
        })
        .catch(function(){ compareCache[h] = {}; });
    }));
  }

  function decorateSale(cart){
    var savingsEl = document.getElementById('cart-savings');
    if(savingsEl) savingsEl.hidden = true;
    if(!saleLive() || !cart.items.length) return;
    var seq = ++saleRenderSeq;
    loadCompare(cart.items).then(function(){
      if(seq !== saleRenderSeq) return; /* a newer cart render owns the DOM */
      var savings = 0;
      cart.items.forEach(function(item){
        var compare = (compareCache[item.handle] || {})[item.variant_id] || 0;
        if(compare <= item.original_price) return;
        var lineCompare = compare * item.quantity;
        savings += lineCompare - item.original_line_price;
        var priceEl = document.querySelector('.cart-item__price[data-line-key="' + item.key + '"]');
        if(priceEl && !priceEl.previousElementSibling){
          var was = document.createElement('s');
          was.className = 'cart-item__was sale-ui';
          was.textContent = formatMoney(lineCompare);
          priceEl.parentNode.insertBefore(was, priceEl);
        }
      });
      if(savingsEl && savings > 0){
        savingsEl.innerHTML = '';
        savingsEl.appendChild(document.createTextNode((window.PSS_SALE.name || 'Sale') + ' savings: –' + formatMoney(savings) + ' '));
        var small = document.createElement('small');
        small.textContent = '(already included)';
        savingsEl.appendChild(small);
        savingsEl.hidden = false;
      }
    });
  }

  function updateCartUI(cart){
    var count = cart.item_count;
    var badge = document.getElementById('cart-badge');
    var countEl = document.getElementById('cart-drawer-count');
    var subtotalEl = document.getElementById('cart-subtotal');
    var footer = document.getElementById('cart-footer');
    var body = document.getElementById('cart-body');

    /* Badge */
    if(badge){
      if(count > 0){ badge.textContent = count; badge.classList.add('show'); }
      else { badge.textContent = '0'; badge.classList.remove('show'); }
    }

    /* Drawer count */
    if(countEl) countEl.textContent = count === 0 ? 'Your cart is empty' : count + ' item' + (count === 1 ? '' : 's');

    if(!body) return;

    if(cart.items.length === 0){
      if(footer) footer.style.display = 'none';
      body.innerHTML =
        '<div class="cart-empty">' +
          '<div class="cart-empty__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div>' +
          '<h3>Your cart is empty</h3>' +
          '<p>Add pine straw and it will appear here.</p>' +
          '<a href="/collections/all" class="btn btn-green btn-lg">Shop Pine Straw</a>' +
        '</div>';
      return;
    }

    if(footer) footer.style.display = 'block';
    var html = '<div class="cart-items">';
    cart.items.forEach(function(item){
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.\w+)$/, '_120x$1') + '" alt="' + item.title + '" style="width:100%;height:100%;object-fit:cover;border-radius:var(--r);">'
        : '🌿';
      html +=
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item__img">' + img + '</div>' +
          '<div class="cart-item__info">' +
            '<div class="cart-item__name">' + item.product_title + '</div>' +
            '<div class="cart-item__meta">' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
            '<div class="cart-item__row">' +
              '<div class="cart-item__qty">' +
                '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="-1">&#8722;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button class="cart-qty-btn" data-key="' + item.key + '" data-delta="1">+</button>' +
              '</div>' +
              '<div>' +
                '<div class="cart-item__price" data-line-key="' + item.key + '">' + formatMoney(item.final_line_price) + '</div>' +
                '<button class="cart-item__remove cart-remove-btn" data-key="' + item.key + '">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    html += '</div>';
    body.innerHTML = html;

    /* Subtotal */
    if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    /* Store sale: strikethroughs + savings line (needs compare-at prices) */
    decorateSale(cart);

    /* Wire up qty buttons */
    body.querySelectorAll('.cart-qty-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-key');
        var delta = parseInt(btn.getAttribute('data-delta'));
        var item = cart.items.find(function(i){ return i.key === key; });
        if(!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        changeCartItem(key, newQty);
      });
    });

    /* Wire up remove buttons */
    body.querySelectorAll('.cart-remove-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        changeCartItem(btn.getAttribute('data-key'), 0);
      });
    });
  }

  function changeCartItem(key, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      updateCartUI(cart);
      bumpBadge();
    })
    .catch(function(e){ console.error('Cart change error:', e); });
  }

  window.addToCartById = function(variantId, qty){
    qty = qty || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id: parseInt(variantId), quantity: qty}]})
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      fetchCart(function(cart){
        updateCartUI(cart);
        openCart();
        bumpBadge();
      });
    })
    .catch(function(e){ console.error('Add to cart error:', e); });
  };

  function bumpBadge(){
    var badge = document.getElementById('cart-badge');
    if(badge){ badge.classList.add('bump'); setTimeout(function(){ badge.classList.remove('bump'); }, 300); }
  }

  /* ══════════════════════════════════════
     CART DRAWER
  ══════════════════════════════════════ */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartOpenBtn = document.getElementById('cart-open-btn');
  var cartCloseBtn = document.getElementById('cart-close-btn');
  var checkoutBtn = document.getElementById('cart-checkout-btn');

  function openCart(){
    if(!cartDrawer) return;
    cartDrawer.classList.add('open');
    if(cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart(){
    if(!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if(cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if(cartOpenBtn) cartOpenBtn.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  if(cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Load cart on page load */
  fetchCart(updateCartUI);

  /* ══════════════════════════════════════
     PRODUCT CARD ADD-TO-CART
  ══════════════════════════════════════ */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-cart]');
    if(!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-add-to-cart');
    if(vid) addToCartById(vid, 1);
  });

  /* ══════════════════════════════════════
     SMOOTH SCROLL (anchors)
  ══════════════════════════════════════ */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var href = a.getAttribute('href');
      /* Links can be retargeted after load (the calculator's Add to Cart buttons start
         as #products and become product URLs) — only scroll for in-page anchors. */
      if(!href || href.charAt(0) !== '#' || href === '#') return;
      var target = document.querySelector(href);
      if(target){
        e.preventDefault();
        /* Clear the sticky header (nav + subnav + any sale bar) — measured, not fixed */
        var hdr = document.getElementById('shopify-section-header');
        var top = target.getBoundingClientRect().top + window.pageYOffset - ((hdr ? hdr.offsetHeight : 98) + 12);
        window.scrollTo({top: top, behavior: 'smooth'});
      }
    });
  });

  /* ══════════════════════════════════════
     SCROLL SPY (homepage section anchors)
  ══════════════════════════════════════ */
  var spySections = ['benefits','products','how','calculator','why','reviews','vs','faq','contact'];
  var anchorMap = {'products':'nav-shop','calculator':'nav-calc','vs':'nav-vs','faq':'nav-faq','contact':'nav-contact'};

  function updateActive(){
    var scrollY = window.pageYOffset + 120, current = '';
    spySections.forEach(function(id){
      var el = document.getElementById(id);
      if(el && el.offsetTop <= scrollY) current = id;
    });
    document.querySelectorAll('.subnav__anchor').forEach(function(a){ a.classList.remove('active'); });
    var mapId = anchorMap[current];
    if(mapId){
      var el = document.getElementById(mapId);
      if(el) el.classList.add('active');
    }
  }
  window.addEventListener('scroll', updateActive, {passive:true});
  updateActive();

  /* ══════════════════════════════════════
     BACK TO TOP
  ══════════════════════════════════════ */
  var btt = document.getElementById('back-to-top');
  window.addEventListener('scroll', function(){
    if(btt) btt.classList.toggle('visible', window.pageYOffset > 400);
  }, {passive:true});
  if(btt) btt.addEventListener('click', function(){ window.scrollTo({top:0, behavior:'smooth'}); });

  /* ══════════════════════════════════════
     FAQ ACCORDION
  ══════════════════════════════════════ */
  document.querySelectorAll('.faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq__item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq__item.open').forEach(function(i){ i.classList.remove('open'); });
      if(!wasOpen) item.classList.add('open');
    });
  });

  /* ══════════════════════════════════════
     SUBNAV STICKY BEHAVIOR
  ══════════════════════════════════════ */
  var subnav = document.getElementById('subnav');
  if(subnav){
    var nav = document.getElementById('main-nav');
    function setSubnavTop(){
      if(nav) subnav.style.top = nav.offsetHeight + 'px';
    }
    setSubnavTop();
    window.addEventListener('resize', setSubnavTop);
  }

})();
